import React from 'react';
import PropTypes from 'prop-types';

import withStyles from 'isomorphic-style-loader/withStyles';
import r from 'quill/dist/quill.snow.css';
import s from './Page.css';
import t from '../../styles/customQuillEditor.css'

const Page = ({ title, html }) => {

  let addClass = 'ql-editor frontend';
  return (
    <div className={s.root}>
      <div className={s.container}>
        <h1>{title}</h1>
        <div className={addClass}
          dangerouslySetInnerHTML={{ __html: html }}
        />
      </div>
    </div>
  );
}

Page.propTypes = {
  title: PropTypes.string.isRequired,
  html: PropTypes.string.isRequired,
};

export default withStyles(r, s, t)(Page);
